import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AddImageComponent } from '../../../../atoms/add-image/add-image.component';
import { S3BucketEnum } from '../../../../common/general-types/media-assets.dto';
import { QuickBriefService } from '../../services/quick-brief.service';

@Component({
  selector: 'qb-promoting-step',
  imports: [AddImageComponent],
  templateUrl: './promoting-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex min-h-0 flex-1 flex-col overflow-hidden' },
})
export class QbPromotingStep {
  readonly brief = inject(QuickBriefService);
  readonly bucket = S3BucketEnum.PRODUCT_IMAGES;

  optionClass(selected: boolean): string {
    return selected
      ? 'border-2 border-primary bg-primary/5'
      : 'border border-border bg-card hover:border-primary';
  }

  onImage(event: { fullUrl: string }): void {
    this.brief.setManualImage(event.fullUrl || '');
  }

  onUrl(event: Event): void {
    this.brief.setProductUrl(inputValue(event));
  }

  onManual(field: 'name' | 'description' | 'price' | 'currency', event: Event): void {
    this.brief.setManualField(field, inputValue(event));
  }
}

function inputValue(event: Event): string {
  const target = event.target;
  if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) {
    return target.value;
  }
  return '';
}
